import { Component, OnInit, Input } from '@angular/core';
import { GetMeNotifiedService } from '@shared/services';
import { Router, NavigationEnd } from '@angular/router';
import { sample } from 'rxjs/operators';

@Component({
  selector: 'app-mailing-component',
  templateUrl: './mailing-component.component.html',
  styleUrls: ['./mailing-component.component.scss']
})
export class MailingComponentComponent implements OnInit {
  isBannerShow: boolean = false;
  isUserLogin: boolean = false;

  constructor(
    private _getMeNotified: GetMeNotifiedService,
    private route: Router
  ) {
    route.events.subscribe(val => {
      // see also
      if (val instanceof NavigationEnd === true) {
        const split = this.route.url.split('/');
        this.isBannerShow = !split.find(i => i === 'dashboard');
      }
    });
  }

  getMeNotified() {
    this._getMeNotified.toggle();
    this._getMeNotified.setPreOrderStatus(false);
  }

  ngOnInit() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
    this.isUserLogin = (currentUser && currentUser.isLogin) || false;
  }
}
